<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'ApAdvanceRequests_Title' | translateWF: 'Advance Requests' }}</h1>
          <p class="page__subtitle">
            {{
              'ApAdvanceRequests_Subtitle'
                | translateWF
                  : 'Request a vendor advance for a provider across purchase
            orders.'
            }}
          </p>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'ApAdvanceRequests_New' | translateWF: 'New request'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'ApAdvanceRequests_Title' | translateWF: 'Advance Requests'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="requests()" selectionMode="single" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'ApAdvanceRequest_Number' | translateWF: 'Request #' }}</th>
                <th>{{ 'ApPayment_Provider' | translateWF: 'Provider' }}</th>
                <th class="text-right">{{ 'ApAdvanceRequest_Total' | translateWF: 'Total' }}</th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
                <th>{{ 'ApAdvanceRequest_Advance' | translateWF: 'Advance' }}</th>
                <th>{{ 'ApAdvanceRequest_Created' | translateWF: 'Created' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let request = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="redirectToDetails(request.id ?? undefined)">{{ request.number }}</a>
                </td>
                <td>{{ request.providerLegalName || request.providerCode }}</td>
                <td class="text-right">{{ request.totalAmount | number: '1.2-2' }} {{ currencyLabel(request.currency) }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(request.status)" [value]="statusLabel(request.status)" />
                </td>
                <td>
                  @if (request.spawnedApAdvanceReference) {
                    <i class="pi pi-check-circle text-green-500" [pTooltip]="'ApAdvanceRequest_HasAdvance' | translateWF: 'Draft advance created'"></i>
                  } @else {
                    <span class="text-surface-400">—</span>
                  }
                </td>
                <td>{{ request.createdDate | date: 'dd/MM/yyyy' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">{{ 'ApAdvanceRequests_NotFound' | translateWF: 'No advance requests found' }}</td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
